import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  getOnboardingCreateStatus,
  createOnboardingAction,
} from 'domains/Dashboard/slices/onBoardingSlice';

const useOnboardingCreate = () => {
  const dispatch = useAppDispatch();
  const status = useSelector(getOnboardingCreateStatus);

  const handleCreateOnboarding = useCallback(
    async (payload = {}) => {
      await dispatch(createOnboardingAction(payload));
    },
    [dispatch],
  );

  return {
    handleCreateOnboarding,
    ...status,
  };
};

export default useOnboardingCreate;
